import React from 'react';
import { Container, Form, Alert } from "react-bootstrap";
import { BfColInput } from '../../../Styling/FormComponents/FormInput'
import { BfYellowRowForm, BfRowSpacer, YellowRoundedContainer, ArticleAreaNySak } from '../../../Styling/styledForm/styledBlueForm'
import styled from 'styled-components';
import useDebitorFormWithAI from './useDebitorFormWithAI';
import CustomToolTip from './CustomToolTip';


const RequiredField = styled.p`
  font-size: 18px; 
  font-weight: 400; 
  color: #000000; 
  padding-left: 24px;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RightIconsContainer = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

const LockIcon = styled.div`
  font-size: 1.4em;
  color: #333;
  padding-right: 20px; 
`;

const DebitorResultForm = ({state, formState, handleChange,
    hasErrorsDebitor, errorMessages, extraErrors, localeMessages, produktOptions,
    debtorTypeOptions, handlePnrChange, setFieldsFromPDF}) => {

    const fakturaInfo = state.pdfInfo;
    const lockDebitorInfo = Object.keys(state.debitorInfo || {}).length !== 0

    const getFormField = (colspan, fieldname, inputType = 'text', selectOptions = '', disabled = lockDebitorInfo, maxLength = 524288,
    ) => {
        return (
        <BfColInput
            colspan={colspan}
            name={fieldname}
            inputType={inputType}
            onChange={handleChange}
            errorMessages={errorMessages}
            extraErrors={extraErrors}
            messages={localeMessages}
            required
            formState={formState}
            selectOptions={selectOptions}
            disabled={disabled}
            maxLength={maxLength}
        />
        );
    };

    const getFormFieldPnr = (colspan, fieldname, inputType = 'text', selectOptions = '', disabled = lockDebitorInfo, maxLength = 524288) => {
        return (
            <BfColInput
                colspan={colspan}
                name={fieldname}
                inputType={inputType}
                onChange={handlePnrChange}
                errorMessages={errorMessages}
                extraErrors={extraErrors}
                messages={localeMessages}
                required
                formState={formState}
                selectOptions={selectOptions}
                disabled={disabled}
                maxLength={maxLength}
            />
        )
    }

    const pStyle = {
        width: '100%'
    }


    const getPrivateRow = () => {
            return (
                <>
                    {getFormField(3, 'requiredFirstName', 'text', false, lockDebitorInfo, 40)}
                    {getFormField(3, 'requiredLastName', 'text', null, lockDebitorInfo, 40)}
                    {getFormField(2, 'requiredBirthDate', 'cleaveDate', null, lockDebitorInfo)}
                    {getFormField(2, 'requiredBirthNumber', 'cleaveFnrNr', null, lockDebitorInfo)}
                </>
            )
    }

    const getNaeringRowRow = () => {
        return (
            <>
                {getFormField(3, 'requiredDebtorIdentificationNumber', 'cleaveOrgNr', null, lockDebitorInfo)}
                {getFormField(6, 'requiredDebtorName', 'text', false, lockDebitorInfo, 40)}
                {formState.debtorNo &&
                    getFormField(2, 'debtorNo', 'text', null, lockDebitorInfo)}

            </>
        )
    }


    return (
        <Container fluid style={pStyle}>

            <ArticleAreaNySak style={{paddingBottom:'20px'}}>
                <h1>{localeMessages.resultDebitorHeader}</h1>
                <p>{localeMessages.resultDebitorP}</p>
            </ArticleAreaNySak>

            <Form autoComplete="chrome-off">
                <YellowRoundedContainer fluid style={{ padding: '15px' }}>

                    {hasErrorsDebitor && (
                        <Alert fluid variant='danger'>
                            {localeMessages.youHaveErrors}
                        </Alert>
                    )}

                    <BfYellowRowForm>
                        {getFormField(4, 'produktType', 'select', produktOptions, lockDebitorInfo)}
                        {getFormField(8, 'referanseNummer', null, null, lockDebitorInfo, 32)}
                    </BfYellowRowForm>

                </YellowRoundedContainer>
                <BfRowSpacer>

                </BfRowSpacer>

                <YellowRoundedContainer fluid style={{ padding: '15px' }}>
                    <RowContainer>
                        <RequiredField>{localeMessages.requiredField}</RequiredField>
                        {lockDebitorInfo && (<RightIconsContainer>
                            <CustomToolTip caption='Midlertidig sak er opprettet og debitorinformasjon er derfor låst. Du må fullfør saken før du kan opprette ny debitor.'>
                                <LockIcon>
                                <i className="fa fa-lock" />
                                </LockIcon>
                            </CustomToolTip>
                        </RightIconsContainer>)}
                    </RowContainer>
                    <BfYellowRowForm>
                        {getFormField(2, 'customerType', 'select', debtorTypeOptions, lockDebitorInfo, 32)}

                        {formState.customerType === 'Næring' &&
                            getNaeringRowRow()
                        }
                        {formState.customerType === 'Privat' &&
                            getPrivateRow()
                        }
                    </BfYellowRowForm>

                    <BfYellowRowForm>
                        {getFormField(3, 'requiredPostalAddress', null, null, lockDebitorInfo, 63)}
                        {getFormField(4, 'requiredStreetAddress', null, null, lockDebitorInfo, 63)}
                        {getFormFieldPnr(2, 'requiredPostalCode', null, null, lockDebitorInfo, 10)}
                        {getFormField(3, 'requiredPostalPlace', null, null, lockDebitorInfo, 30)}
                    </BfYellowRowForm>

                    <BfYellowRowForm>
                        {getFormField(4, 'requiredEmail', null, null, lockDebitorInfo, 63)}
                        {getFormField(3, 'requiredPhone', null, null, lockDebitorInfo, 15)}
                        {getFormField(2, 'requiredCountryCode', null, null, lockDebitorInfo, 3)}
                    </BfYellowRowForm>

                    <BfYellowRowForm>
                        {getFormField(12, 'caseMessage', 'textarea', null, lockDebitorInfo)}
                    </BfYellowRowForm>
                </YellowRoundedContainer>
            </Form>
        </Container>
    )
}

export default DebitorResultForm

